document.addEventListener("DOMContentLoaded", function () {
  const cartButton = document.getElementById("cart-toggle-button");
  const cartDrawer = document.getElementById("cart-drawer");
  const navElements = document.querySelectorAll(".main-nav__child");
  const body = document.body;

  function applySavedState() {
    let isOpen = localStorage.getItem("cartDrawerOpen") === "true";

    cartDrawer.classList.toggle("hidden", !isOpen);
    cartButton.setAttribute("data-open", isOpen ? "true" : "false");

    if (isOpen) {
      body.classList.add("body-with-drawer");
      body.classList.remove("body-no-drawer");
      body.classList.remove("hide-cart-overflow-hidden");
    } else {
      body.classList.add("body-no-drawer");
      body.classList.remove("body-with-drawer");
      body.classList.add("hide-cart-overflow-hidden");
    }

    navElements.forEach((element) => {
      element.classList.add("nav-menu-element");
    });
  }

  cartButton.addEventListener("click", function () {
    if (window.innerWidth <= 1400) {
      window.location.href = "/cart";
      return;
    }

    let isOpen = cartButton.getAttribute("data-open") === "true";
    let newState = !isOpen;

    localStorage.setItem("cartDrawerOpen", newState);
    cartDrawer.classList.toggle("hidden", !newState);
    cartButton.setAttribute("data-open", newState ? "true" : "false");

    if (newState) {
      body.classList.add("body-with-drawer");
      body.classList.remove("body-no-drawer");
      body.classList.remove("hide-cart-overflow-hidden");
    } else {
      body.classList.add("body-no-drawer");
      body.classList.remove("body-with-drawer");
      body.classList.add("hide-cart-overflow-hidden");
    }

    navElements.forEach((element) => {
      element.classList.add("nav-menu-element");
    });
  });

  function handleResize() {
    if (window.innerWidth < 1400) {
      localStorage.setItem("cartDrawerOpen", false);
      cartDrawer.classList.add("hidden");
      cartButton.setAttribute("data-open", "false");
      body.classList.add("body-no-drawer");
      body.classList.remove("body-with-drawer");
      body.classList.add("hide-cart-overflow-hidden");
    }
  }

  applySavedState();
  handleResize();
  window.addEventListener("resize", handleResize);
});
